import React, { createContext, useContext, useRef } from 'react';

// Define the shape of the context
interface AppContextType {
  appRef: React.RefObject<HTMLIonAppElement>;
}

// Create the context with a default value (undefined)
const AppContext = createContext<AppContextType | undefined>(undefined);

// Hook to easily access the context
export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};

// AppProvider component that wraps the app and provides the ref
export const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const appRef = useRef<HTMLIonAppElement>(null); // Create the ref

  return (
    <AppContext.Provider value={{ appRef }}>
      {children}
    </AppContext.Provider>
  );
};
